import {
  Document,
  Packer,
  Paragraph,
  Table,
  TableRow,
  TableCell,
  WidthType,
  VerticalAlign,
  ImageRun,
  BorderStyle, TextRun, AlignmentType,
} from 'docx';
import { saveAs } from 'file-saver';
import staffPresenceReportLogo from '../../../assets/images/staffPresenceReportLogo.png';

const useStaffPresenceReport = (props) => {
  const { ATCU, dataSource, year, month, day } = props;

  const mapPresentStaffMembers = () => {
    const array = [];

    if (!!dataSource && dataSource?.controllers?.length > 0) {
      dataSource?.controllers?.forEach((el) => {
        if ((ATCU?.label?.includes('ATCU I ') && el?.location === 'SA') || (ATCU?.label?.includes('ATCU II') && el?.location === 'BL')) {
          array.push({
            name: el?.firstName + ' ' + el?.lastName,
            shiftName: el?.shift?.name
          });
        }
      });
    }
    return array;
  };

  const getStaffPresenceReport = async () => {
    const staffNamesArray = mapPresentStaffMembers();

    const logoBlob = await fetch(staffPresenceReportLogo).then((r) => r.blob())
    const logoArrayBuffer = await logoBlob.arrayBuffer();

    const tableBorders = {
      top: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
      bottom: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
      left: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
      right: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
    };

    const cellPadding = {
      top: 100,
      bottom: 100,
      left: 200,
      right: 200,
    }

    const centered = (text) => {
      return (
          new Paragraph({
            text,
            alignment: AlignmentType.CENTER,
          })
      );
    }

    const doc = new Document({
      sections: [
        {
          children: [
            new Table({
              width: {
                size: 100,
                type: WidthType.PERCENTAGE,
              },
              rows: [
                new TableRow({
                  children: [
                    new TableCell({
                      verticalAlign: VerticalAlign.CENTER,
                      rowSpan: 2,
                      margins: cellPadding,
                      borders: tableBorders,
                      children: [
                        new Paragraph({
                          children: [
                            new ImageRun({
                              data: logoArrayBuffer,
                              transformation: { width: 230, height: 50 },
                            }),
                          ],
                        }),
                      ],
                    }),
                    new TableCell({
                      borders: tableBorders,
                      children: [
                          new Paragraph('Oznaka:'),
                          new Paragraph('ATC.FORM.118')
                      ],
                      margins: cellPadding
                    }),
                    new TableCell({
                      borders: tableBorders,
                      children: [
                          new Paragraph('Verzija:'),
                          new Paragraph('2.0')
                      ],
                      margins: cellPadding
                    }),
                    new TableCell({
                      borders: tableBorders,
                      children: [centered('ATC.UPU.019')],
                      margins: cellPadding,
                      verticalAlign: 'center'
                    }),
                  ],
                }),
                new TableRow({
                  children: [
                    new TableCell({
                      columnSpan: 3,
                      borders: tableBorders,
                      margins: cellPadding,
                      children: [centered({
                        children: [
                          new TextRun({ text: 'LISTA PRISUTNOSTI OPERATIVNOG OSOBLJA BHACC', bold: true })
                        ]
                      })],
                    }),
                  ],
                }),
              ],
            }),
            new Paragraph(' \n'),
            new Table({
              width: {
                size: 100,
                type: WidthType.PERCENTAGE,
              },
              rows: [
                // === DATUM / TIM / SMJENA ===
                new TableRow({
                  children: [
                    new TableCell({
                      columnSpan: 1,
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 16, color: '000000' },
                        left: { style: BorderStyle.SINGLE, size: 16, color: '000000' },
                        right: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
                        bottom: { style: BorderStyle.SINGLE, size: 2, color: '000000' }
                      },
                      width: {
                        size: 35,
                        type: WidthType.PERCENTAGE,
                      },
                      children: [new Paragraph({
                        children: [
                          new TextRun({ text: ('DATUM: ' + day + '.' + month + '.' + year), bold: true })
                        ]
                      })],
                      margins: cellPadding
                    }),
                    new TableCell({
                      columnSpan: 1,
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 16, color: '000000' },
                        left: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
                        right: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
                        bottom: { style: BorderStyle.SINGLE, size: 2, color: '000000' }
                      },
                      children: [new Paragraph({
                        children: [
                          new TextRun({ text: 'TIM:', bold: true })
                        ]
                      })],
                      margins: cellPadding
                    }),
                    new TableCell({
                      columnSpan: 1,
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 16, color: '000000' },
                        left: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
                        right: { style: BorderStyle.SINGLE, size: 16, color: '000000' },
                        bottom: { style: BorderStyle.SINGLE, size: 2, color: '000000' }
                      },
                      children: [new Paragraph({
                        children: [
                          new TextRun({ text: 'SMJENA:', bold: true })
                        ]
                      })],
                      margins: cellPadding
                    }),
                  ],
                }),
                new TableRow({
                  children: [
                    new TableCell({
                      columnSpan: 1,
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
                        left: { style: BorderStyle.SINGLE, size: 16, color: '000000' },
                        right: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
                        bottom: { style: BorderStyle.SINGLE, size: 16, color: '000000' }
                      },
                      children: [new Paragraph({
                        children: [
                          new TextRun({ text: 'IME I PREZIME', bold: true })
                        ]
                      })],
                      margins: cellPadding
                    }),
                    new TableCell({
                      columnSpan: 2,
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
                        left: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
                        right: { style: BorderStyle.SINGLE, size: 16, color: '000000' },
                        bottom: { style: BorderStyle.SINGLE, size: 16, color: '000000' }
                      },
                      children: [new Paragraph({
                        children: [
                          new TextRun({ text: 'POTPIS', bold: true })
                        ]
                      })],
                      margins: cellPadding
                    })
                  ],
                }),

                ...Array.from(staffNamesArray).map(
                    (el) => new TableRow({
                      height: { value: 400, rule: 'atLeast' },
                      children: [
                        new TableCell({
                          columnSpan: 1,
                          borders: {
                            top: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
                            left: { style: BorderStyle.SINGLE, size: 16, color: '000000' },
                            right: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
                            bottom: { style: BorderStyle.SINGLE, size: 2, color: '000000' }
                          },
                          margins: cellPadding,
                          children: [new Paragraph(el?.name)],
                          verticalAlign: 'center'
                        }),
                        // new TableCell({
                        //   columnSpan: 4,
                        //   borders: tableBorders,
                        //   children: [new Paragraph('')],
                        // }),
                        new TableCell({
                          columnSpan: 2,
                          borders: {
                            top: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
                            left: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
                            right: { style: BorderStyle.SINGLE, size: 16, color: '000000' },
                            bottom: { style: BorderStyle.SINGLE, size: 2, color: '000000' }
                          },
                          children: [new Paragraph({
                            children: [
                              new TextRun({
                                text: el?.shiftName,
                                bold: true,
                                color: '#e30000'
                              })
                            ],
                            alignment: 'right'
                          })],
                          margins: cellPadding,
                        }),
                      ],
                    })
                ),
                new TableRow({
                  height: { value: 400, rule: 'atLeast' },
                  children: [
                    new TableCell({
                      columnSpan: 1,
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
                        left: { style: BorderStyle.SINGLE, size: 16, color: '000000' },
                        right: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
                        bottom: { style: BorderStyle.SINGLE, size: 16, color: '000000' }
                      },
                      margins: cellPadding,
                      children: [new Paragraph({
                        children: [
                          new TextRun({ text: 'ŠS(SUP)/SATCO:', bold: true })
                        ],
                      })],
                      verticalAlign: 'center'
                    }),
                    new TableCell({
                      columnSpan: 2,
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
                        left: { style: BorderStyle.SINGLE, size: 2, color: '000000' },
                        right: { style: BorderStyle.SINGLE, size: 16, color: '000000' },
                        bottom: { style: BorderStyle.SINGLE, size: 16, color: '000000' }
                      },
                      children: [new Paragraph('')],
                    })
                  ]
                })
              ]
            })
          ],
        },
      ],
    });

    const blob = await Packer.toBlob(doc);
    saveAs(blob, `Lista prisutnosti operativnog osoblja - ${ATCU?.label} ${day + '.' + month + '.' + year + '.'}.docx`);
  };

  return {
    getStaffPresenceReport
  };
};

export default useStaffPresenceReport;
